import HttpService from '../services/HttpService';

export const UPDATE_LOADING_START = 'driver@update_driver_loading_start';
export const UPDATE_DRIVERS = 'driver@update_drivers';
export const UPDATE_VEHICLES = 'driver@update_vehicles';
export const UPDATE_DRIVER_AND_VEHICLES = 'driver@update_driver_and_vehicles';
export const CLEAR_DATA = 'driver@clear_vehicle_driver_data';

const waitResolveListeners = {
  drivers: [],
  vehicles: [],
};

const resolvePromise = async (promiseResolver: () => void) => {
  try {
    promiseResolver();
  } catch (e) {
    console.error(e);
  }
};

const dispatchListeners = (type: 'drivers' | 'vehicles' | 'both') => {
  if ('both' === type || 'vehicles' === type) {
    waitResolveListeners.vehicles.forEach(resolvePromise);
    waitResolveListeners.vehicles = [];
  }
  if ('both' === type || 'drivers' === type) {
    waitResolveListeners.drivers.forEach(resolvePromise);
    waitResolveListeners.drivers = [];
  }
};

export const getSiteDriversAndVehicles = (force = false, apptDate = null) => {
  return (dispatch, getState) => {
    const state = getState();

    if (state.DriversReducer.loadingVehicles || state.DriversReducer.loadingDrivers) {
      return new Promise((resolve) => {
        if (state.DriversReducer.loadingVehicles) {
          waitResolveListeners.vehicles.push(resolve);
        }
        if (state.DriversReducer.loadingDrivers) {
          waitResolveListeners.drivers.push(resolve);
        }
      });
    }

    if (!force && state.DriversReducer.drivers.length > 0 && state.DriversReducer.vehicles.length > 0) {
      return;
    }

    dispatch({
      type: UPDATE_LOADING_START,
      payload: ['drivers', 'vehicles'],
    });

    return gSD(apptDate).then((data) => {
      dispatch({ type: UPDATE_DRIVER_AND_VEHICLES, payload: data });
      dispatchListeners('both');
    });
  };
};

export const clearDriverVehicleData = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLEAR_DATA });
  };
};

export const gSD = (apptDate = null) => {
  return HttpService.get(`/admin/vehicles-with-drivers?appt_date=${apptDate}`)
    .then((response) => response.json())
    .then((data) => data);
};
